import { render, staticRenderFns } from "./connectAbroad.vue?vue&type=template&id=48a3aca1&scoped=true"
import script from "./connectAbroad.vue?vue&type=script&lang=js"
export * from "./connectAbroad.vue?vue&type=script&lang=js"
import style0 from "./connectAbroad.vue?vue&type=style&index=0&id=48a3aca1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a3aca1",
  null
  
)

export default component.exports